import type { ReactNode } from "react";

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label>
      <span>{label}</span>
      {children}
    </label>
  );
}

export function Pill({ value }: { value: string }) {
  return <span className={`ops-pill ops-pill--${value}`}>{value}</span>;
}

export function Count({ n, label }: { n: number; label: string }) {
  return (
    <span className="ops-count">
      {n} {label}
    </span>
  );
}

export function Empty({ children }: { children: string }) {
  return <p className="ops-empty">{children}</p>;
}

export function Thumb({ src }: { src?: string }) {
  return src ? <img alt="" className="ops-thumb" src={src} /> : <span className="ops-thumb ops-thumb--empty" />;
}
